import React, { Component } from 'react';
import { Navbar, NavbarBrand } from 'reactstrap';

class PartnerHeader extends Component {
  render() {
    return (
      <div>
        <Navbar light className="navbar-partner">
          <NavbarBrand className="text-hide" href="/">LendingUSA Partner</NavbarBrand>
        </Navbar>
      </div>
    );
  }
}

export default PartnerHeader;
